// BotPros branding assets + version marker (bp-branding-v1).
// Referenced by LoginPage + the global toolbar so a live-bundle marker grep can
// confirm the branding shipped. Bump the version suffix when the logo/favicon
// set is re-cut so cached HTML/asset references can be reasoned about.

export const BP_BRANDING_VERSION = 'bp-branding-v1'

// Full "bot pros" lockup, colored icon + WHITE wordmark — for DARK surfaces
// (the login hero + the #0f172a global toolbar). Black wordmark on dark would
// be invisible, so the wordmark is recolored white while the icon keeps its
// brand blues.
export const BP_LOGO_DARK = '/bp-logo-full-dark.webp'

// Full lockup with the original BLACK wordmark — for light surfaces.
export const BP_LOGO_LIGHT = '/bp-logo-full.webp'

export const BP_LOGO_ALT = 'Bot Pros'
